import React from "react"
import styled from "styled-components"
import colors from "../../../../styles/colors"

const StyledSvg = styled.svg`
  transition: color 0.2s ease;
  &:hover {
    path {
      fill: ${colors.green};
    }
  }
`

const Bag = ({ large }) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={large ? 23 : 17}
      height={large ? 21 : 15}
      viewBox="0 0 17 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1476 13.65H3.30754L1.50523 5.97187H4.80278V7.25156H5.67515V5.97187H11.7817V7.25156H12.6541V5.97187H15.9202L14.1476 13.65ZM5.67588 4.17948C5.67588 2.34526 7.0455 0.852292 8.72917 0.852292C10.4128 0.852292 11.7825 2.34526 11.7825 4.17948V5.11792H5.67588V4.17948ZM12.6553 5.11875V4.18031C12.6553 1.87687 10.9106 0 8.72965 0C6.54873 0 4.80399 1.87687 4.80399 4.18031V5.11875H0.423828L2.62656 14.5031H14.8336L16.9988 5.11875H12.6553Z"
        fill="black"
      />
    </StyledSvg>
  )
}

export default Bag
